import React, {ReactNode} from 'react'
import styled from '@emotion/styled'

import {Button} from '@vio/atlas/Button'
import {Icon} from '@vio/atlas/Icon'
import {ANIMATION_TYPES, Overlay} from '@vio/atlas/Overlay'
import {ImageProvider} from '@vio/core/src/staticContent/types/ImageProvider'

import {AccommodationFloatingHeader} from '../AccommodationFloatingHeader'
import {
  backgroundColorStyles,
  Footer,
  GalleryWrapper,
  OverlayContent
} from './styles'
import {VirtualizedGallery} from './VirtualizedGallery'

interface Props {
  /** Is the overlay opened */
  isOpen: boolean
  /** RTL language */
  isRtl: boolean
  /** Array of image URLs */
  images: string[]
  /** First image to display after opening */
  initialImageIndex: number
  /** Add elements to the left side of the header (after the close button) */
  leftHeaderButtonSlot?: ReactNode
  /** Add elements to the right side of the header */
  rightHeaderButtonSlot?: ReactNode
  /** Add elements to the bottom of the overlay */
  footerSlot?: ReactNode
  /** Imaging service for resizing */
  imageProvider: ImageProvider
  /** Triggered whenever the user swipes the gallery */
  onSwipe?: () => void
  /** Triggered whenever the user zooms the gallery */
  onZoom?: () => void
  /** Handle overlay close */
  onClose: () => void
  /** Whether to show the left header button slot */
  hasLeftHeaderButtonSlot?: boolean
}
// Lightbox acts as a full screen overlay, higher z-index allows it to be on top of PopUp
const StyledOverlay = styled(Overlay)`
  z-index: 101;
`
export const LightboxGalleryMobile = ({
  isOpen,
  isRtl,
  initialImageIndex,
  images,
  leftHeaderButtonSlot,
  rightHeaderButtonSlot,
  footerSlot,
  imageProvider,
  onSwipe,
  onZoom,
  onClose,
  hasLeftHeaderButtonSlot = true
}: Props) => {
  return (
    <StyledOverlay
      enableBodyScrollLock
      isOpen={isOpen}
      shadeBackground={false}
      customStyles={backgroundColorStyles}
      animationType={ANIMATION_TYPES.NONE}
    >
      <OverlayContent>
        <GalleryWrapper>
          <VirtualizedGallery
            imageProvider={imageProvider}
            images={images}
            initialImageIndex={initialImageIndex}
            isRtl={isRtl}
            onSwipe={onSwipe}
            onZoom={onZoom}
            isZoomEnabled
          />
        </GalleryWrapper>
        {footerSlot ? <Footer>{footerSlot}</Footer> : null}
      </OverlayContent>
      <AccommodationFloatingHeader
        leftSlot={
          <>
            {hasLeftHeaderButtonSlot && (
              <Button
                variant="tertiary"
                isRounded
                isFloating
                dataId="BackButton"
                iconStart={<Icon name="Close" />}
                onClick={onClose}
                size="lg"
              />
            )}
            {leftHeaderButtonSlot}
          </>
        }
        rightSlot={rightHeaderButtonSlot}
      />
    </StyledOverlay>
  )
}
